import { PromptType } from '../constants/parameters';
import { AccountSecurityPromptActionType } from '../store/action';
import { AccountSecurityPromptContext } from '../store/contextProvider';
import ModalState from '../store/modalState';

export const dismissTemporary = (
  dispatch: AccountSecurityPromptContext['dispatch']
) => (): void => {
  dispatch({ type: AccountSecurityPromptActionType.DISMISS_TEMPORARY });
};

export const startDismissForever = (
  dispatch: AccountSecurityPromptContext['dispatch'],
  promptType: PromptType
) => (): void => {
  dispatch({
    type: AccountSecurityPromptActionType.SET_MODAL_STATE,
    modalState:
      promptType === PromptType.ADD_EMAIL
        ? ModalState.ADD_EMAIL_DISMISS_CONFIRMATION
        : ModalState.CHANGE_PASSWORD_DISMISS_CONFIRMATION
  });
};

export const returnToIntro = (dispatch: AccountSecurityPromptContext['dispatch']) => (): void =>
  dispatch({
    type: AccountSecurityPromptActionType.SET_MODAL_STATE,
    modalState: ModalState.CHANGE_PASSWORD_INTRO
  });
